export default __webpack_public_path__ + "static/media/interswitchForPayment.44a3e57c.svg";